import { useTranslation } from 'react-i18next';
import { withStyles } from 'vopay';
import { Button } from 'UI';
import { TRANSFER_FORM_ID, TransferFlow } from './useTransferForm';
import styles from './TransferForm.module.scss';

const cn = withStyles(styles);

type TransferFormActionsProps = {
  flow: TransferFlow;
  /** The drawer's footer stretches the buttons across it; the page keeps them right-aligned. */
  fullWidth?: boolean;
};

/**
 * Review / Previous / Submit for the transfer form. Rendered wherever the host wants them (the page
 * puts them under the card, the drawer in its footer); the `form` attribute keeps them submitting
 * the form either way.
 */
export default function TransferFormActions({
  flow: { ctx, isReviewing, isRoleViewOnly, backToEdit },
  fullWidth = false,
}: TransferFormActionsProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'PartnerAccountTransfer' });

  return (
    <div className={cn('footer', fullWidth && 'fullWidth')}>
      {isReviewing ? (
        <>
          <Button id="account-transfer-back" type="button" disabled={ctx.isSubmitting} onClick={backToEdit}>
            {t('Review.backButtonLabel', { defaultValue: 'Previous' })}
          </Button>

          <Button
            id="account-transfer-submit"
            type="submit"
            form={TRANSFER_FORM_ID}
            colorScheme="primary"
            disabled={isRoleViewOnly || !ctx.isValid || ctx.isSubmitting}
          >
            {t('Review.submitButtonLabel', { defaultValue: 'Submit' })}
          </Button>
        </>
      ) : (
        <Button
          id="account-transfer-review"
          type="submit"
          form={TRANSFER_FORM_ID}
          colorScheme="primary"
          disabled={isRoleViewOnly || !ctx.isValid}
        >
          {t('submitButton', { defaultValue: 'Review' })}
        </Button>
      )}
    </div>
  );
}
